import React from 'react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import PasswordForm from '../components/PasswordForm';
import SubscriptionPanel from '../components/SubscriptionPanel';

const Profile = ({ user }) => (
  <>
    <Card className="mb-6">
      <CardContent className="pt-6 space-y-1">
        <p className="font-medium">{user?.full_name}</p>
        <p className="text-sm text-muted-foreground">{user?.email}</p>
      </CardContent>
    </Card>
    <Card>
      <CardHeader>
        <CardTitle className="font-heading uppercase">Changer mon mot de passe</CardTitle>
      </CardHeader>
      <CardContent>
        <PasswordForm
          currentLabel="Mot de passe actuel"
          submitLabel="Changer mon mot de passe"
          onChanged={() => toast.success('Mot de passe changé')}
        />
      </CardContent>
    </Card>
  </>
);

// The subscription belongs to the organisation: an account without one (Levitics' own) has only its profile.
const Account = () => {
  const { user } = useAuth();

  return (
    <div className="p-4 sm:p-8 max-w-2xl" data-testid="account-page">
      <h1 className="font-heading font-bold text-3xl uppercase text-primary mb-8">Mon compte</h1>
      {user?.organisation_id ? (
        <Tabs defaultValue="profile">
          <TabsList className="mb-6">
            <TabsTrigger value="profile" data-testid="tab-profile">Profil</TabsTrigger>
            <TabsTrigger value="subscription" data-testid="tab-subscription">Abonnement</TabsTrigger>
          </TabsList>
          <TabsContent value="profile"><Profile user={user} /></TabsContent>
          <TabsContent value="subscription"><SubscriptionPanel /></TabsContent>
        </Tabs>
      ) : (
        <Profile user={user} />
      )}
    </div>
  );
};

export default Account;
